// import React, { useEffect, useMemo } from 'react';
// import {
//    Card,
//    CardHeader,
//    Heading,
//    CardBody,
//    TableContainer,
//    Table,
//    Thead,
//    Tr,
//    Td,
//    Th,
//    Tbody,
//    useColorModeValue,
// } from '@chakra-ui/react';
// import { useSelector, useDispatch } from 'react-redux';
// import { useUser } from 'contexts/UserContext';
// import moment from 'moment';
// import { getRojmel } from '../../../../redux/actions/dashboard';

// const Rojmel = () => {
//    const dispatch = useDispatch();
//    const { user } = useUser();

//    // Color mode values
//    const borderColor = useColorModeValue('gray.300', 'gray.600');
//    const headerBg = useColorModeValue('gray.100', 'gray.700');
//    const rowBg = useColorModeValue('white', 'gray.800');
//    const highlightRowBg = useColorModeValue('gray.50', 'gray.600');
//    const textColor = useColorModeValue('gray.800', 'white');
//    const borderWidth = useColorModeValue('1px', '1px');

//    const rojmelData = useSelector((state) => state?.dashboard?.rojmelList || []);

//    const openingSales = useMemo(() => {
//       return rojmelData?.toReceiveAndPay?.find((item) => item.accountname === 'To Receive')?.osamt || 0;
//    }, [rojmelData]);

//    const openingPurchase = useMemo(() => {
//       return rojmelData?.toReceiveAndPay?.find((item) => item.accountname === 'To Pay')?.osamt || 0;
//    }, [rojmelData]);

//    const sales = useMemo(() => {
//       return rojmelData?.salesAndPurchaseRegister?.find((item) => item.description === 'Sales')?.amt || 0;
//    }, [rojmelData]);

//    const purchase = useMemo(() => {
//       return rojmelData?.salesAndPurchaseRegister?.find((item) => item.description === 'Purchase')?.amt || 0;
//    }, [rojmelData]);

//    const exchange = useMemo(() => {
//       return rojmelData?.salesAndPurchaseRegister?.find((item) => item.description === 'Exchange')?.amt || 0;
//    }, [rojmelData]);

//    const totalCashBankBalance = useMemo(() => {
//       return rojmelData?.cashBankBalance?.reduce((acc, item) => acc + Number(item?.today_received || 0), 0);
//    }, [rojmelData]);

//    const cashBankBalance = useMemo(() => {
//       return (
//          rojmelData?.cashBankBalance?.map((item) => {
//             const totalOpeningAndSales = Number(item.opening_balance) + Number(item.today_received);
//             const totalPurchaseAndExpenses = Number(item.today_paid) + Number(item.today_paid_against_expenses);
//             const totalClosing = Number(item.closingbal) - totalOpeningAndSales - totalPurchaseAndExpenses;
//             return (
//                <Tr key={item.id}>
//                   <Td fontWeight="medium" color={textColor}>
//                      {item.account_name}
//                   </Td>
//                   <Td color={textColor}>{parseFloat(item.opening_balance?.toFixed(2))}</Td>
//                   <Td color={textColor}>{parseFloat(item.today_received?.toFixed(2))}</Td>
//                   <Td color={textColor}>{parseFloat(item.today_paid?.toFixed(2))}</Td>
//                   <Td color={textColor}>{parseFloat(item.today_paid_against_expenses?.toFixed(2))}</Td>
//                   <Td color={textColor}>{parseFloat(totalClosing?.toFixed(2))}</Td>
//                   <Td color={textColor}>{parseFloat(item.closingbal?.toFixed(2))}</Td>
//                </Tr>
//             );
//          }) || []
//       );
//    }, [rojmelData, textColor]);

//    useEffect(() => {
//       if (!user?.loginhistory?.companyId) return;
//       dispatch(
//          getRojmel({
//             companyId: user?.loginhistory?.companyId,
//             fromDate: moment().format('YYYY-MM-DD'),
//             toDate: moment().format('YYYY-MM-DD'),
//          }),
//       );
//    }, [dispatch, user?.loginhistory?.companyId]);

//    return (
//       <Card
//          flexDirection="column"
//          w="100%"
//          px="0px"
//          overflowX={{ sm: 'scroll', lg: 'hidden' }}
//          position="relative"
//          bg={rowBg}>
//          <CardHeader>
//             <Heading size="sm" color={textColor}>
//                ROJMEL
//             </Heading>
//          </CardHeader>
//          <CardBody>
//             <TableContainer border={borderWidth} borderColor={borderColor} borderRadius="md">
//                <Table
//                   variant="simple"
//                   size="sm"
//                   sx={{
//                      border: borderWidth,
//                      borderColor: borderColor,
//                      borderRadius: 'md',
//                      overflow: 'hidden',
//                      'th, td': {
//                         border: borderWidth,
//                         borderColor: borderColor,
//                         padding: '8px',
//                         color: textColor,
//                      },
//                      tr: {
//                         border: borderWidth,
//                         borderColor: borderColor,
//                         bg: rowBg,
//                      },
//                      'thead tr': {
//                         backgroundColor: headerBg,
//                      },
//                   }}>
//                   <Thead>
//                      <Tr>
//                         <Th color={textColor}> </Th>
//                         <Th color={textColor}>Opening</Th>
//                         <Th color={textColor}>Sales Register</Th>
//                         <Th color={textColor}>Purchase Register</Th>
//                         <Th color={textColor}>Expense</Th>
//                         <Th color={textColor}>Other Transaction</Th>
//                         <Th color={textColor}>Closing</Th>
//                      </Tr>
//                   </Thead>
//                   <Tbody>
//                      <Tr>
//                         <Td fontWeight="sm" color={textColor}>
//                            Opening
//                         </Td>
//                         <Td color={textColor}>-</Td>
//                         <Td color={textColor}>{parseFloat(openingSales?.toFixed(2))}</Td>
//                         <Td color={textColor}>{parseFloat(openingPurchase?.toFixed(2))}</Td>
//                         <Td color={textColor}>-</Td>
//                         <Td color={textColor}>-</Td>
//                         <Td color={textColor}>-</Td>
//                      </Tr>
//                      <Tr>
//                         <Td fontWeight="sm" color={textColor}>
//                            Total
//                         </Td>
//                         <Td color={textColor}>-</Td>
//                         <Td color={textColor}>{parseFloat(sales?.toFixed(2))}</Td>
//                         <Td color={textColor}>{parseFloat(purchase?.toFixed(2))}</Td>
//                         <Td color={textColor}>-</Td>
//                         <Td color={textColor}>-</Td>
//                         <Td color={textColor}>-</Td>
//                      </Tr>
//                      {cashBankBalance}
//                      <Tr>
//                         <Td fontWeight="sm" color={textColor}>
//                            Exchange
//                         </Td>
//                         <Td color={textColor}>-</Td>
//                         <Td color={textColor}>{parseFloat(exchange?.toFixed(2))}</Td>
//                         <Td color={textColor}>{parseFloat(exchange?.toFixed(2))}</Td>
//                         <Td color={textColor}>-</Td>
//                         <Td color={textColor}>-</Td>
//                         <Td color={textColor}>-</Td>
//                      </Tr>
//                      <Tr fontWeight="semibold" bg={highlightRowBg}>
//                         <Td color={textColor}>Closing</Td>
//                         <Td color={textColor}>-</Td>
//                         <Td color={textColor}>
//                            {parseFloat(
//                               (Number(openingSales) - Number(totalCashBankBalance) - Number(exchange))?.toFixed(2),
//                            )}
//                         </Td>
//                         <Td color={textColor}>
//                            {parseFloat(
//                               (Number(openingPurchase) - Number(totalCashBankBalance) - Number(exchange))?.toFixed(2),
//                            )}
//                         </Td>
//                         <Td color={textColor}>-</Td>
//                         <Td color={textColor}>-</Td>
//                         <Td color={textColor}>-</Td>
//                      </Tr>
//                   </Tbody>
//                </Table>
//             </TableContainer>
//          </CardBody>
//       </Card>
//    );
// };

// export default Rojmel;

import React, { useEffect, useMemo, useState } from 'react';
import { useColorMode } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import { useUser } from 'contexts/UserContext';
import moment from 'moment';
import { getRojmel } from '../../../../redux/actions/dashboard';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { RotateCw } from 'lucide-react';

const Rojmel = ({ datePartyWiseSalesRange, setPartyWiseSalesDateRange, reload }) => {
   const dispatch = useDispatch();
   const { user } = useUser();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [isRotating, setIsRotating] = useState(false);

   const rojmelData = useSelector((state) => state?.dashboard?.rojmelList || []);

   const openingSales = useMemo(() => {
      return rojmelData?.toReceiveAndPay?.find((item) => item.accountname === 'To Receive')?.osamt || 0;
   }, [rojmelData]);

   const openingPurchase = useMemo(() => {
      return rojmelData?.toReceiveAndPay?.find((item) => item.accountname === 'To Pay')?.osamt || 0;
   }, [rojmelData]);

   const sales = useMemo(() => {
      return rojmelData?.salesAndPurchaseRegister?.find((item) => item.description === 'Sales')?.amt || 0;
   }, [rojmelData]);

   const purchase = useMemo(() => {
      return rojmelData?.salesAndPurchaseRegister?.find((item) => item.description === 'Purchase')?.amt || 0;
   }, [rojmelData]);

   const exchange = useMemo(() => {
      return rojmelData?.salesAndPurchaseRegister?.find((item) => item.description === 'Exchange')?.amt || 0;
   }, [rojmelData]);

   const totalCashBankBalance = useMemo(() => {
      return rojmelData?.cashBankBalance?.reduce((acc, item) => acc + Number(item?.today_received || 0), 0);
   }, [rojmelData]);

   const cashBankBalance = useMemo(() => {
      return (
         rojmelData?.cashBankBalance?.map((item) => {
            const totalOpeningAndSales = Number(item.opening_balance) + Number(item.today_received);
            const totalPurchaseAndExpenses = Number(item.today_paid) + Number(item.today_paid_against_expenses);
            const totalClosing = Number(item.closing_balance) - totalOpeningAndSales - totalPurchaseAndExpenses;
            return (
               <tr
                  key={item.id}
                  className={`transition-colors duration-150 ${isDark ? 'bg-gray-800 hover:bg-gray-750' : 'bg-white hover:bg-gray-50'
                     }`}>
                  <td
                     className={`border px-2 sm:px-4 py-2 sm:py-3 font-medium text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-200' : 'border-gray-200 text-gray-900'
                        }`}>
                     {item.account_name}
                  </td>
                  <td
                     className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700' : 'border-gray-200'
                        } ${item.opening_balance > 0
                           ? isDark
                              ? 'text-red-400'
                              : 'text-red-600'
                           : isDark
                              ? 'text-green-400'
                              : 'text-green-600'
                        }`}>
                     <span className="whitespace-nowrap">
                        {parseFloat(Math.abs(item.opening_balance)?.toFixed(2)).toLocaleString()}{' '}
                        {item.opening_balance > 0 ? 'CR' : 'DB'}
                     </span>
                  </td>
                  <td
                     className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-green-400' : 'border-gray-200 text-green-600'
                        }`}>
                     {parseFloat(item.today_received?.toFixed(2)).toLocaleString()}
                  </td>
                  <td
                     className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-red-400' : 'border-gray-200 text-red-600'
                        }`}>
                     {parseFloat(item.today_paid?.toFixed(2)).toLocaleString()}
                  </td>
                  <td
                     className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-orange-400' : 'border-gray-200 text-orange-600'
                        }`}>
                     {parseFloat(item.today_paid_against_expenses?.toFixed(2)).toLocaleString()}
                  </td>
                  <td
                     className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700' : 'border-gray-200'
                        } ${item.other_amt > 0
                           ? isDark
                              ? 'text-green-400'
                              : 'text-green-600'
                           : isDark
                              ? 'text-red-400'
                              : 'text-red-600'
                        }`}>
                     {parseFloat(item.other_amt?.toFixed(2)).toLocaleString()}
                  </td>
                  <td
                     className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-semibold text-xs sm:text-sm ${isDark ? 'border-gray-700' : 'border-gray-200'
                        } ${item.closing_balance > 0
                           ? isDark
                              ? 'text-red-400'
                              : 'text-red-600'
                           : isDark
                              ? 'text-green-400'
                              : 'text-green-600'
                        }`}>
                     <span className="whitespace-nowrap">
                        {parseFloat(Math.abs(item.closing_balance)?.toFixed(2)).toLocaleString()}{' '}
                        {item.closing_balance > 0 ? 'CR' : 'DB'}
                     </span>
                  </td>
               </tr>
            );
         }) || []
      );
   }, [rojmelData, isDark]);

   useEffect(() => {
      if (!user?.loginhistory?.companyId) return;
      if (user && user?.packageData?.[0]?.isRojmel) {
         dispatch(
            getRojmel({
               companyId: user?.loginhistory?.companyId,
               fromDate: moment().format('YYYY-MM-DD'),
               toDate: moment().format('YYYY-MM-DD'),
            }),
         );
      }
   }, [dispatch, user]);

   const handleDateRangeChange = (dates) => {
      if (!dates || dates.length !== 2) return;

      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));
      if (user && user?.packageData?.[0]?.isRojmel && user?.loginhistory?.companyId) {
         dispatch(
            getRojmel({
               companyId: user?.loginhistory?.companyId,
               fromDate: from,
               toDate: to,
            }),
         );
      }

      setPartyWiseSalesDateRange({ fromDate: from, toDate: to });
   };

   useEffect(() => {
      setPartyWiseSalesDateRange({ fromDate: moment().format('YYYY-MM-DD'), toDate: moment().format('YYYY-MM-DD') });
   }, []);

   const handleReload = async () => {
      setIsRotating(true);
      if (user && user?.packageData?.[0]?.isRojmel && user?.loginhistory?.companyId) {
         dispatch(
            getRojmel({
               companyId: user?.loginhistory?.companyId,
               fromDate: moment().format('YYYY-MM-DD'),
               toDate: moment().format('YYYY-MM-DD'),
            }),
         );
      }
      setTimeout(() => setIsRotating(false), 700);
   };

   // Calculate closing balances for final row
   const closingSalesBalance = Number(openingSales) - Number(totalCashBankBalance) - Number(exchange);
   const closingPurchaseBalance = Number(openingPurchase) - Number(totalCashBankBalance) - Number(exchange);

   return (
      <div className={`flex flex-col w-full transition-colors duration-200 ${isDark ? 'bg-gray-900' : 'bg-gray-50'}`}>
         {/* Header Section */}
         <div
            className={`sticky top-0 z-10 ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
               } border-b shadow-sm`}>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4 px-3 sm:px-6 py-3 sm:py-4">
               <div className="flex items-center gap-2 sm:gap-3">
                  <div className={`w-1 h-6 sm:h-8 rounded-full ${isDark ? 'bg-blue-500' : 'bg-blue-600'}`}></div>
                  <h2
                     className={`text-lg sm:text-xl font-bold tracking-tight ${isDark ? 'text-white' : 'text-gray-900'
                        }`}>
                     ROJMEL
                  </h2>
               </div>
               <div className="flex items-center">
                  <div className="flex w-full sm:w-auto">
                     <PeriodDatePicker
                        value={[new Date(datePartyWiseSalesRange?.fromDate), new Date(datePartyWiseSalesRange?.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="today"
                        style={{ width: '100%', minWidth: '200px', maxWidth: '250px' }}
                     />

                     <button
                        onClick={handleReload}
                        className={`ml-2 p-2 rounded-full transition-all duration-300 hover:scale-110 ${isDark ? 'hover:bg-gray-700 text-blue-400' : 'hover:bg-gray-100 text-blue-600'
                           }`}>
                        <RotateCw
                           className={`w-5 h-5 transform ${isRotating ? 'rotate-[360deg]' : ''
                              } transition-transform ease-in-out`}
                           style={{
                              transitionDuration: isRotating ? '700ms' : '10ms',
                           }}
                        />
                     </button>
                  </div>
               </div>
            </div>
         </div>

         {/* Content Section */}
         <div className="px-2 sm:px-4 md:px-6 py-3 sm:py-4 md:py-6">
            <div
               className={`rounded-lg sm:rounded-xl shadow-lg overflow-hidden ${isDark ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-200'
                  }`}>
               <div className="overflow-x-auto">
                  <div className="min-w-[800px]">
                     <table className="w-full text-xs sm:text-sm border-collapse">
                        <thead className={`${isDark ? 'bg-gray-750' : 'bg-gradient-to-r from-gray-50 to-gray-100'}`}>
                           <tr>
                              <th
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-left font-semibold text-[10px] sm:text-xs uppercase tracking-wider ${isDark ? 'border-gray-700 text-gray-300' : 'border-gray-200 text-gray-700'
                                    }`}>
                                 Account
                              </th>
                              <th
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-semibold text-[10px] sm:text-xs uppercase tracking-wider whitespace-nowrap ${isDark ? 'border-gray-700 text-gray-300' : 'border-gray-200 text-gray-700'
                                    }`}>
                                 Opening Balance
                              </th>
                              <th
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-semibold text-[10px] sm:text-xs uppercase tracking-wider ${isDark ? 'border-gray-700 text-gray-300' : 'border-gray-200 text-gray-700'
                                    }`}>
                                 Sales
                              </th>
                              <th
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-semibold text-[10px] sm:text-xs uppercase tracking-wider ${isDark ? 'border-gray-700 text-gray-300' : 'border-gray-200 text-gray-700'
                                    }`}>
                                 Purchase
                              </th>
                              <th
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-semibold text-[10px] sm:text-xs uppercase tracking-wider ${isDark ? 'border-gray-700 text-gray-300' : 'border-gray-200 text-gray-700'
                                    }`}>
                                 Expense
                              </th>
                              <th
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-semibold text-[10px] sm:text-xs uppercase tracking-wider whitespace-nowrap ${isDark ? 'border-gray-700 text-gray-300' : 'border-gray-200 text-gray-700'
                                    }`}>
                                 Other Trans.
                              </th>
                              <th
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-semibold text-[10px] sm:text-xs uppercase tracking-wider whitespace-nowrap ${isDark ? 'border-gray-700 text-gray-300' : 'border-gray-200 text-gray-700'
                                    }`}>
                                 Closing Balance
                              </th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr
                              className={`transition-colors duration-150 ${isDark ? 'bg-gray-800 hover:bg-gray-750' : 'bg-white hover:bg-gray-50'
                                 }`}>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 font-medium text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-200' : 'border-gray-200 text-gray-900'
                                    }`}>
                                 Opening OS
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-medium text-xs sm:text-sm ${isDark ? 'border-gray-700 text-green-400' : 'border-gray-200 text-green-600'
                                    }`}>
                                 {parseFloat(openingSales?.toFixed(2)).toLocaleString()}
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-medium text-xs sm:text-sm ${isDark ? 'border-gray-700 text-red-400' : 'border-gray-200 text-red-600'
                                    }`}>
                                 {parseFloat(openingPurchase?.toFixed(2)).toLocaleString()}
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                           </tr>
                           <tr
                              className={`transition-colors duration-150 ${isDark ? 'bg-gray-800 hover:bg-gray-750' : 'bg-white hover:bg-gray-50'
                                 }`}>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 font-medium text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-200' : 'border-gray-200 text-gray-900'
                                    }`}>
                                 Total Amount
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-medium text-xs sm:text-sm ${isDark ? 'border-gray-700 text-green-400' : 'border-gray-200 text-green-600'
                                    }`}>
                                 {parseFloat(sales?.toFixed(2)).toLocaleString()}
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-medium text-xs sm:text-sm ${isDark ? 'border-gray-700 text-red-400' : 'border-gray-200 text-red-600'
                                    }`}>
                                 {parseFloat(purchase?.toFixed(2)).toLocaleString()}
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                           </tr>
                           {cashBankBalance}
                           <tr
                              className={`transition-colors duration-150 ${isDark ? 'bg-gray-800 hover:bg-gray-750' : 'bg-white hover:bg-gray-50'
                                 }`}>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 font-medium text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-200' : 'border-gray-200 text-gray-900'
                                    }`}>
                                 Exchange
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-medium text-xs sm:text-sm ${isDark ? 'border-gray-700 text-purple-400' : 'border-gray-200 text-purple-600'
                                    }`}>
                                 {parseFloat(exchange?.toFixed(2)).toLocaleString()}
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right font-medium text-xs sm:text-sm ${isDark ? 'border-gray-700 text-purple-400' : 'border-gray-200 text-purple-600'
                                    }`}>
                                 {parseFloat(exchange?.toFixed(2)).toLocaleString()}
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                           </tr>
                           <tr
                              className={`font-bold ${isDark
                                 ? 'bg-gradient-to-r from-gray-700 to-gray-750'
                                 : 'bg-gradient-to-r from-blue-50 to-indigo-50'
                                 }`}>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-xs sm:text-sm ${isDark ? 'border-gray-700 text-blue-400' : 'border-gray-200 text-blue-700'
                                    }`}>
                                 Closing Balance
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700' : 'border-gray-200'
                                    } ${closingSalesBalance > 0
                                       ? isDark
                                          ? 'text-red-400'
                                          : 'text-red-700'
                                       : isDark
                                          ? 'text-green-400'
                                          : 'text-green-700'
                                    }`}>
                                 <span className="whitespace-nowrap">
                                    {parseFloat(closingSalesBalance?.toFixed(2)).toLocaleString()}{' '}
                                    {closingSalesBalance > 0 ? 'CR' : 'DB'}
                                 </span>
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700' : 'border-gray-200'
                                    } ${closingPurchaseBalance > 0
                                       ? isDark
                                          ? 'text-red-400'
                                          : 'text-red-700'
                                       : isDark
                                          ? 'text-green-400'
                                          : 'text-green-700'
                                    }`}>
                                 <span className="whitespace-nowrap">
                                    {parseFloat(closingPurchaseBalance?.toFixed(2)).toLocaleString()}{' '}
                                    {closingPurchaseBalance > 0 ? 'CR' : 'DB'}
                                 </span>
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                              <td
                                 className={`border px-2 sm:px-4 py-2 sm:py-3 text-right text-xs sm:text-sm ${isDark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'
                                    }`}>
                                 -
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Rojmel;
